export const MAIL_FOLDERS = {
    SENT_ITEMS: "Sent Items",
    INBOX: "Inbox",
};
export const OUTLOOK_MAIL_CREATION_SOURCE = {
    ADMINISTRATOR: "ADMINISTRATOR",
};
//# sourceMappingURL=mail.js.map